import { useNavigate } from '@tanstack/react-router';
import { Button } from '@/kit';

/**
 * Pantalla informativa de configuración MFA por correo en primer login.
 *
 * El backend NO soporta enrolar MFA con la `session` del challenge: el login
 * siempre emite EMAIL_OTP. Por eso esta pantalla (alcanzable solo vía la ruta
 * inalcanzable `/login/mfa-email-setup`) ya NO llama endpoints removidos; solo
 * explica que la configuración del método de verificación se hace desde el
 * perfil una vez dentro.
 */
export function MfaEmailWizard() {
    const navigate = useNavigate();

    return (
        <div className="mx-auto max-w-md space-y-4 text-center">
            <h1 className="text-2xl font-semibold">Configuración de verificación</h1>
            <p className="text-sm text-muted-foreground">
                La configuración del método de verificación se realiza desde tu perfil una vez que
                hayas iniciado sesión.
            </p>
            <Button
                onClick={() => {
                    void navigate({ to: '/login' });
                }}
            >
                Volver al inicio de sesión
            </Button>
        </div>
    );
}
